import { KYMW0B00Component } from './kymw0b00.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { GetKYMW0B00InitResponse } from './api-services/get_kymw0B00_init.service';

/**
 * 画像検索画面の値を管理するクラス
 *
 * @export KYMW0B00Model
 * @class KYMW0B00Model
 */
export class KYMW0B00Model {

  kymw0B00Component: KYMW0B00Component;

  /** 作成指示者リスト  */
  public imageInstructUserList: Array<any> = new Array<any>();
  /** 画像作成指示リスト */
  public imageInstructDivList: Array<any> = new Array<any>();
  /** 画像使用不可リスト */
  public imageEnableDivList: Array<any> = new Array<any>();
  /** 出力/未入力選択リスト */
  public outputFlgList: Array<any> = new Array<any>();
  /** 作成指示日・開始   */
  public imageInstructDateStart: string = <string>'';
  /** 作成指示日・終了  */
  public imageInstructDateEnd: string = <string>'';
  /** 画像ファイル登録日・開始 */
  public fileRegistDateStart: string = <string>'';
  /** 画像ファイル登録日・終了   */
  public fileRegistDateEnd: string = <string>'';
  /** 撮影予定日・開始 */
  public photoScheduleStart: string = <string>'';
  /** 撮影予定日・終了 */
  public photoScheduleEnd: string = <string>'';
  /** Pコード */
  public pcode: string = <string>'';
  /** 商品案内用商品名  */
  public guideGoodsName: string = <string>'';
  /** 商品案内用規格名 */
  public guideStandardName: string = <string>'';
  /** 使用開始受注コード */
  public startOrderCode: string = <string>'';
  /** 使用開始配達企画回(翌週) */
  public startDelivCatalogId: string = <string>'';
  /** 部門コード */
  public classCode: string = <string>'';
  /** 画像名 */
  public imageName: string = <string>'';
  /** 画像ファイル名 */
  public imageFileName: string = <string>'';
  /** 画像所属 */
  public imageBelongID: string = <string>'';
  /** 画像種類 */
  public imageKind: string = <string>'';
  /** 画像種別 */
  public imageType: string = <string>'';
  /** 調理指示 */
  public processInstruct: string = <string>'';
  /** 調理例掲載区分 */
  public cookingExPublish = false;
  /** 備考 */
  public remarks: string = <string>'';
  /** 料理分類チェック */
  public cookingExPublishSelected = false;
  /** 料理分類 */
  public cookingDiv: string = <string>'';
  /** 料理名 */
  public cookingName: string = <string>'';
  /** 材料名 */
  public materialName: string = <string>'';
  /** キーワード */
  public keyWord: string = <string>'';
  /** 季節・催事 */
  public eventID: string = <string>'';
  /** 撮影場所 */
  public photoStudio: string = <string>'';
  /** 撮影場所区分 */
  public photoContentsDiv: string = <string>'';
  /** 画像ステータス */
  public imageStatus: string = <string>'';
  /** 作成指示者 */
  public imageInstructUser: string = <string>'';
  /** 作成指示区分 */
  public imageInstructDiv: string = <string>'';
  /** 画像ステータス */
  public status: string = <string>'';
  /** 画像作成指示 */
  public imageInstrucrDiv: string = <string>'';
  /** 画像使用不可 */
  public imageEnableDiv: string = <string>'0';
  /** 繰越 */
  public carriedForward = false;
  /** 変更前撮影予定日 */
  public photographingChangeSchedule = false;
  /** 複数コード登録 */
  public multipleCode = false;
  /** スタジオ */
  public studio: string = <string>'';
  /** 請求先名 */
  public billingName: string = <string>'';
  /** バイヤーコード */
  public buyerCode: string = <string>'';
  /** 出力/未出力選択 */
  public outputFlg: string = <string>'';
  /** C2PFステータス */
  public c2pfStatus: string = <string>'';
  /** 画像使用方法 */
  public imageUse: string = <string>'';
  /** C2PF対象 */
  public c2pfTarget = false;
  /** 取引先コメント */
  public supplierComment = false;
  /** Pコードリスト */
  public pcodeList: string = <string>'';
  /** 選択タブ */
  public tabSelectIndex: number = <number>0;
  /** 処理区分 */
  public processDiv: string = <string>'0';

  /**表示・非表示用のC2PF検索項目表示フラグ */
  public c2pfSearchVisibleFlg: string = <string>'';

  /**
   * 画像検索の初期データ取得
   * @param data:サーバから取得されたXMLデータ
   */
  public updateKYMW0B00Init(serverData: GetKYMW0B00InitResponse): void {
    if (serverData == null) {
      this.imageInstructDivList = new Array<any>();
      this.imageEnableDivList = new Array<any>();
      return;
    }

    // 作成指示者コンボボックス生成
    const imageInstructUser: Array<any> = serverData;
    const showInstructUserArray: Array<any> = new Array<any>();

    // 先頭の空白行を設定
    showInstructUserArray.push({lbl: '', code: ''});
    for (let j = Number(0); j < imageInstructUser.length; j++) {
      // コード+：+名称追加
      const lbl: string = PlessViewUtilsSub.nullToBlank(imageInstructUser[j].UserID) + ': ' +
        PlessViewUtilsSub.nullToBlank(imageInstructUser[j].UserName);
      showInstructUserArray.push({lbl: lbl, code: PlessViewUtilsSub.nullToBlank(imageInstructUser[j].UserID)});
    }

    this.imageInstructUserList =  showInstructUserArray;

  }


  /**
   * 固定値のコンボボックスを生成
   */
  public initComboBoxData(): void {
    // 画像作成指示　コンボボックスのデータを設定
    const cmbImageInstructDiv: Array<any> = new Array<any>();
    cmbImageInstructDiv.push({lbl: '' , code: ''});
    cmbImageInstructDiv.push({lbl: 'あり' , code: '1'});
    cmbImageInstructDiv.push({lbl: 'なし' , code: '2'});
    this.imageInstructDivList = cmbImageInstructDiv;

    // 画像使用不可　コンボボックスのデータを設定
    const cmbImageEnabledDiv: Array<any> = new Array<any>();
    if (this.processDiv === '1') {
      cmbImageEnabledDiv.push({lbl: '使用可' , code: '0'});
      cmbImageEnabledDiv.push({lbl: '使用不可' , code: '1'});
    } else if (this.processDiv === '2') {
      cmbImageEnabledDiv.push({lbl: '使用可' , code: '0'});
      cmbImageEnabledDiv.push({lbl: '使用不可' , code: '1'});
    } else if (this.processDiv === '3') {
      cmbImageEnabledDiv.push({lbl: '使用可' , code: '0'});
    }
    this.imageEnableDivList = cmbImageEnabledDiv;

    // 出力/未出力選択　コンボボックスのデータを設定
    const cmbOutputFlg: Array<any> = new Array<any>();
    cmbOutputFlg.push({lbl: '', code: ''});
    cmbOutputFlg.push({lbl: '1:出力済', code: '1'});
    cmbOutputFlg.push({lbl: '2:未出力', code: '2'});
    this.outputFlgList = cmbOutputFlg;
  }
}
